import React, { useEffect, useState } from 'react';
import { Row, Col, Form } from 'antd';
import Loadable from '@/components/common/loadable';
import Modal from '@/components/common/modal';
import Button from '@/components/common/button';
import IconLocationOutlined from '@/assets/images/icons/icons-location-outlined.svg';
import IconCalendarOutlined from '@/assets/images/icons/icons-calendar-outlined.svg';
import IconClockOutlined from '@/assets/images/icons/icons-clock-outlined.svg';
import Input from '@/components/common/input';
import './index.scss';
import { ICON } from '@/components/common/icon/iconFlag';

const { Item } = Form;
const RefundedList = Loadable({
  loader: () => import('@/components/transaction/refund/list'),
});
const Map = Loadable({
  loader: () => import('@/components/common/map'),
});
const EmailModal = Loadable({
  loader: () => import('@/components/transaction/detail/email-modal'),
});
const RefundModal = Loadable({
  loader: () => import('@/components/transaction/refund'),
});
export default ({ isOpen = false, onCloseProp }) => {
  const [isOpenEmailModal, setOpenEmailModal] = useState(false);
  const [isOpenRefundModal, setOpenRefundModal] = useState(false);

  useEffect(() => {
    // console.log('🚀 ~ file: index.jsx ~ line 14 ~ useEffect ~ useEffect', isOpen);
  }, [isOpen]);

  const onOpenEmailModal = () => {
    setOpenEmailModal(!isOpenEmailModal);
  };

  const onOpenRefundModal = () => {
    setOpenRefundModal(!isOpenRefundModal);
  };

  const modalFooter = () => (
    <Row>
      <Col span={12}>
        <Button
          type="primary"
          size="large"
          // onClick={onClose}
          fixedIcon
          flagIcon={ICON.ICONS_REFUND}
          className="btn-back"
          onClick={onOpenRefundModal}
        >
          Refund
        </Button>
      </Col>
      <Col span={6}>
        <Button
          type="primary"
          size="large"
          fixedIcon
          flagIcon={ICON.ICONS_MAIL_FILLED}
          className="btn-white"
          onClick={onOpenEmailModal}
        >
          Email
        </Button>
      </Col>
      <Col span={6}>
        <Button
          type="primary"
          size="large"
          fixedIcon
          flagIcon={ICON.ICONS_PRINT}
          className="btn-white"
        >
          Print
        </Button>
      </Col>
    </Row>
  );

  return (
    <Modal
      title="Order Information"
      open={isOpen}
      onClose={onCloseProp}
      destroyOnClose
      width="80%"
      renderFooter={modalFooter()}
      className="transaction-detail"
    >
      <>
        <Row className="section-header">
          <Col span={12} className="header-left">
            <p className="bus-title">Business Name Placeholder</p>
            <p className="map-title">
              <img className="fixed-icon icon" src={IconLocationOutlined} alt="icon" />6 Middlemiss
              Street, Lavender Bay NSW, Australia
            </p>
          </Col>
          <Col span={12} className="header-right">
            <p className="label-title">Order ID</p>
            <p className="trans-id">OL - 192892982</p>
          </Col>
        </Row>
        <Row className="section-mid">
          <Col span={12} className="mid-left">
            <Map
              center={{
                lat: -33.84246,
                lng: 151.20976,
              }}
            />
          </Col>
          <Col span={12} className="mid-right">
            <Row>
              <Col span={8}>
                <p className="label-title">Order Value</p>
                <p className="number">$65.00</p>
              </Col>
              <Col span={8} />
              <Col span={8} className="no-items">
                <p className="label-title">No. of Items</p>
                <p className="number">4</p>
              </Col>
            </Row>
            <Form layout="vertical">
              <Row gutter={24}>
                <Col span={8}>
                  <Item label="Tax Amount">
                    <Input editMode defaultValue="00.00" />
                  </Item>
                </Col>
                <Col span={8}>
                  <Item label="Discount Amount">
                    <Input editMode defaultValue="00.00" />
                  </Item>
                </Col>
                <Col span={8}>
                  <Item label="Tip Amount">
                    <Input editMode defaultValue="00.00" />
                  </Item>
                </Col>
              </Row>
              <Item label="Status">
                <Button type="primary" size="large" fixedIcon={false}>
                  Payed
                </Button>
              </Item>
              <Row gutter={16}>
                <Col span={12}>
                  <Item label="Authentication Date">
                    <Input editMode defaultValue="Wed, 14 Jul 2021" icon={IconCalendarOutlined} />
                  </Item>
                </Col>
                <Col span={12}>
                  <Item label="Authentication Time">
                    <Input editMode defaultValue="14:32:56" icon={IconClockOutlined} />
                  </Item>
                </Col>
              </Row>
              <Item label="Authentication Response">
                <Input editMode defaultValue="N/A" />
              </Item>
              <Item label="Staff member">
                <Input editMode defaultValue="Naomi Yepes" />
              </Item>
              <Item label="Signature">
                <Input editMode defaultValue="N/A" />
              </Item>
              <Item label="Note">
                <Input editMode defaultValue="N/A" />
              </Item>
            </Form>
          </Col>
        </Row>
      </>

      <Row>
        <RefundedList />
      </Row>

      {/* START: EMAIL MODAL */}
      <EmailModal isOpen={isOpenEmailModal} onCloseProp={onOpenEmailModal} />
      {/* END: EMAIL MODAL */}

      {/* START: REFUND MODAL */}
      <RefundModal isOpen={isOpenRefundModal} onCloseProp={onOpenRefundModal} />
      {/* END: REFUND MODAL */}
    </Modal>
  );
};
